import domReady from '@wordpress/dom-ready';
import { _x } from '@wordpress/i18n';

domReady(() => {
  const variationSliders = document.querySelectorAll(
    '.product_price__variation-slider-input'
  );
  const productBlock = document.querySelector('.product-block');

  if (
    !variationSliders.length ||
    !productBlock ||
    !productBlock.dataset.cartUrl
  ) {
    return;
  }

  variationSliders.forEach((slider) => {
    const parentPrice = slider.closest('.product_price');
    if (!parentPrice) return;

    const variationContainer = parentPrice.querySelector(
      '.product_price__variation-slider-container'
    );
    if (!variationContainer || !variationContainer.dataset.variations) return;

    let variationsData;
    try {
      variationsData = JSON.parse(variationContainer.dataset.variations);
    } catch (e) {
      console.error('Erreur de parsing des données de variations :', e);
      return;
    }

    slider.addEventListener('input', (e) => {
      const value = e.target.value;
      const variation = variationsData[value];
      if (!variation) return;

      const productPrice = parentPrice.querySelector('.product_price__number');
      if (productPrice) {
        const price = variation.price.replace(/[\s$,\.]/g, '');
        productPrice.innerHTML =
          price > 0 ? variation.price : _x('Free', 'Product price', 'vtx');
      }

      const productPriceDescription = parentPrice.querySelector(
        '.product_price__number-description'
      );
      const productPricePromotion = parentPrice.querySelector(
        '.product_price__promo'
      );

      if (productPriceDescription && productPricePromotion) {
        if (variation.label === 'Mensuel') {
          productPriceDescription.innerHTML = _x(
            '/ Month',
            'Product price description',
            'vtx'
          );
          productPricePromotion.innerHTML = '';
        } else if (variation.label === 'Annuel') {
          productPriceDescription.innerHTML = _x(
            '/ Year',
            'Product price description',
            'vtx'
          );
          productPricePromotion.innerHTML = `<span class="product_price__promo-text">${_x(
            'Save 1 month',
            'Product price promotion',
            'vtx'
          )}</span>`;
        } else {
          productPriceDescription.innerHTML = '';
          productPricePromotion.innerHTML = '';
        }
      }

      const labels = parentPrice.querySelectorAll(
        '.product_price__variation-label'
      );
      if (labels.length >= 2) {
        labels.forEach((label, index) => {
          const isSelected = index === parseInt(value);
          label.style.color = isSelected ? 'white' : 'black';
          label.style.backgroundColor = isSelected ? '#7B75FF' : 'transparent';
        });
      }
    });
  });
});
